import './App.scss';
import { Route, Routes } from 'react-router-dom';
import Layout from "./components/Layout/Layout"
import Home from './components/Home/Home';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import Portfolio from './components/Portfolio/Portfolio';
import Tips from './components/Tips/Tips';
import JsTips from './components/Tips/JS/JsTips';
import ReactTips from './components/Tips/React/ReactTips';
import NodeJsTips from './components/Tips/NodeJs/NodeJsTips';

function App() {
    return (
        <>
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<Home />} />
                    <Route path="about" element={<About />} />
                    <Route path="tips" element={<Tips />} />
                    <Route path='/portfolio' element={<Portfolio />} />
                    <Route path="/contact" element={<Contact />} />

                    {/* Tips */}
                    <Route path="/jsTips" element={<JsTips />} />
                    <Route path="/reactTips" element={<ReactTips />} />
                    <Route path="/NodeJsTips" element={<NodeJsTips />} />

                </Route>
            </Routes>
        </>
    )
}

export default App
